import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Pill } from "PFComponents/pill";
import { Typography } from "PFComponents/typography";
import { Color } from "PFCore/types";
import { KPIStatus } from "PFCore/types/kpi";
import { getAdaptiveTextColor } from "PFCore/utilities/color";
import { IconName } from "PFTheme/graphics/icons";
import { useTranslation } from "react-i18next";

const STATUS_TO_ICON: Record<string, IconName | null> = {
  [KPIStatus.OnTarget]: "check",
  [KPIStatus.ApprovalGranted]: "check",
  [KPIStatus.ApprovalRequested]: "hourglass-half",
  [KPIStatus.ApprovalRejected]: "forbidden",
  [KPIStatus.ApprovalRequired]: "error"
};

const STATUS_TO_PILL_COLOR: Record<string, Color> = {
  [KPIStatus.OnTarget]: "paletteGreen2",
  [KPIStatus.ApprovalGranted]: "paletteGreen2",
  [KPIStatus.ApprovalRequested]: "paletteOrange2",
  [KPIStatus.ApprovalRejected]: "paletteRed2",
  [KPIStatus.ApprovalRequired]: "paletteRed2"
};

type KPIPillProps = {
  kpiStatus: KPIStatus;
  kpiName?: string;
};

export const KPIPill = ({ kpiStatus, kpiName }: KPIPillProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "kpi" });
  const { themeVars } = useTheme();

  const statusIcon = STATUS_TO_ICON[kpiStatus];
  const pillColor = themeVars[STATUS_TO_PILL_COLOR[kpiStatus]];

  return (
    <Pill color={pillColor} small>
      <Inline alignItems="center" gap="spacingSm">
        {statusIcon && <Icon name={statusIcon} size="sm" fill={getAdaptiveTextColor(pillColor)} />}
        <Typography variant="labelRegular">
          {kpiName ??
            t(`status.${kpiStatus}` as unknown as TemplateStringsArray, { defaultValue: kpiStatus })}
        </Typography>
      </Inline>
    </Pill>
  );
};
